<div #container class="relative" tabindex="-1" (focusout)="onFocusOut($event)">
    <button type="button" class="avatar | group" (click)="togglePopover()" [ngClass]="{ '!bg-white': open$ | async }">
        <app-icon class="text-base text-white group-hover:text-secondary" [ngClass]="{ '!text-secondary': open$ | async }" [name]="'mingcute:user-3-line'" />
    </button>

    <app-profile-popover @Grow *ngIf="open$ | async" [type]="type" />
</div>
